import script from "./Hierarchy.vue?vue&type=script&setup=true&lang=js"
export * from "./Hierarchy.vue?vue&type=script&setup=true&lang=js"

import "./Hierarchy.vue?vue&type=style&index=0&id=2485ddbc&lang=css"
import "./Hierarchy.vue?vue&type=style&index=1&id=2485ddbc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2485ddbc"]])

export default __exports__